import { addMinutes } from 'date-fns/addMinutes';
import { assertNonNullable } from '@/lib/utils';
import { db } from '../db';
import type { UsersSchema } from '../schemas/users';

const TOKEN_EXPIRED_MIN = 15 as const;
export const TOKEN_LIFETIME_MS = TOKEN_EXPIRED_MIN * 60_000;
const getTokenExpiredDate = () => addMinutes(new Date(), TOKEN_EXPIRED_MIN);

export const addUser = async (user: Omit<UsersSchema, 'tokenExpiredAt'>) => {
  await db.users.put({ ...user, tokenExpiredAt: getTokenExpiredDate() });
};

export function getCurrentUser(): Promise<UsersSchema | undefined>;
export function getCurrentUser(options: {
  nonNullable: true;
}): Promise<UsersSchema>;
export async function getCurrentUser(options?: { nonNullable: boolean }) {
  const user = (await db.users.limit(1).toArray()).at(0);
  if (options?.nonNullable) {
    assertNonNullable(user);
  }
  return user;
}

export const updateUserToken = async (
  userId: string,
  newToken: Pick<UsersSchema, 'token' | 'refreshToken'>,
) => {
  const tokenExpiredAt = getTokenExpiredDate();
  const updatedCount = await db.users.update(userId, {
    ...newToken,
    tokenExpiredAt,
  });
  return { tokenExpiredAt, updatedCount };
};
